<template>
  <div v-if="provider">
    <b-tabs no-fade>
      <b-tab active>
        <template #title>
          <feather-icon class="mb-25 mb-lg-none" icon="InfoIcon" />
          <span class="d-none d-lg-block">{{ $t("Informació") }}</span>
        </template>

        <b-row>
          <b-col cols="12">
            <summary-card />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { notifyError } from "@/utils/methods";
import SummaryCard from "@/views/providers/provider/components/SummaryCard.vue";
import { BRow, BCol, BTabs, BTab } from "bootstrap-vue";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    SummaryCard,
  },
  computed: {
    loading() {
      return this.$store.getters["provider/loading"];
    },
    provider() {
      return this.$store.getters["provider/provider"];
    },
  },
  watch: {
    provider(provider) {
      this.setPageTitle(provider);
    },
    "$route.params.providerUuid"() {
      this.fetchProvider();
    },
  },
  mounted() {
    if (!this.loading) this.fetchProvider();
    this.setPageTitle(this.provider);
  },
  beforeDestroy() {
    this.$store.dispatch("provider/reset");
    this.setPageTitle(null);
  },
  methods: {
    fetchProvider() {
      this.$store.dispatch("app/setLoading", true);
      const { providerUuid } = this.$route.params;

      this.$store
        .dispatch("provider/fetchProvider", providerUuid)
        .catch(() =>
          notifyError(
            this.$t("errors.fetchProviders.title"),
            this.$t("errors.fetchProviders.description")
          )
        )
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
    setPageTitle(provider) {
      this.$store.dispatch("app/setPageTitle", provider?.fullName || null);
    },
  },
};
</script>
